/**
 * <CheckoutModalStripeWrapper />
 *
 * @parent Header
 * @stateless
 */
import React, { PropTypes } from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import CheckoutModal from './CheckoutModal';
import { confirmable } from 'react-confirm';

let key = ''
let indicator = '';

let api_key = ''

if (process.env.APP_ENV == "development"){
  key = "pk_test_smD2brB7NmCVjHNZcZ8Iu4BD"
} else{
  try {
    api_key = require("./Stripe_key.js")
    key = api_key.STRIPE_API_KEY;
    indicator = api_key.INDICATOR;
  } catch (e) {
    alert(e);
  }
}


class CheckoutModalStripeWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {


    return (
      <div>
        <input type='hidden' value={indicator} />
        <StripeProvider apiKey={key}>
          <Elements>
            <CheckoutModal {...this.props} />
          </Elements>
        </StripeProvider>
      </div>  
    )
  }
}

export default confirmable(CheckoutModalStripeWrapper);



// WEBPACK FOOTER //
// ./src/template/Modals/MyStoreCheckout/CheckoutModalStripeWrapper.js